import {
  ArrayField,
  Datagrid,
  NumberField,
  SimpleShowLayout,
  TextField,
  useRecordContext,
} from 'react-admin';
import * as React from 'react';
import Heading from 'components/Heading';

const ReleaseLegsTab = () => (
  <SimpleShowLayout>
    <Heading>Release Legs</Heading>
    <ArrayField source="release_path" data-testid="job_show-release_legs_array">
      <Datagrid bulkActionButtons={false} data-testid="job_show-release_legs_table">
        <TextField
          label="Category"
          source="category"
          data-testid="job_show-release_legs_category"
        />
        <NumberField
          label="Window Hours"
          source="window_hours"
          data-testid="job_show-release_legs_window_hours"
        />
        <TextField
          label="Exclusive Professional IDs"
          source="exclusive_professional_ids"
          data-testid="job_show-release_legs_exclusive_professional_ids"
        />
        <NumberField
          label="Exclusive Offset Hours"
          source="exclusive_offset_hours"
          data-testid="job_show-release_legs_exclusive_offset_hours"
        />
      </Datagrid>
    </ArrayField>
  </SimpleShowLayout>
);

export default ReleaseLegsTab;
